// Path: ./src/hooks/useHandleCompleteOnboarding.ts
import { useHandleSaveOnboardingMerchant } from "./useHandleSaveOnboardingMerchant";
import { useHandleSaveOnboardingStore } from "./useHandleSaveOnboardingStore";
import { useNavigate } from "react-router-dom";
import { toastSuccess } from "../utils/pageUtil/toast";
import {
  StandardizedOnboardingData,
  getMerchantForSaving,
  getStoreForSaving,
  validateOnboardingData,
} from "../app/pages/OnBoardingPage/utils/onboardingDataTransformer";
import { useHandleSubscription } from "./useHandleSubscription";

interface CompleteOnboardingOptions {
  onSuccess?: () => void;
  onError?: (error: any) => void;
  redirectPath?: string;
}

export const useHandleCompleteOnboarding = () => {
  const navigate = useNavigate();
  const handleSaveOnboardingMerchant = useHandleSaveOnboardingMerchant();
  const handleSaveOnboardingStore = useHandleSaveOnboardingStore();
  const handleUpdateSubscription = useHandleSubscription();
  const handleCompleteOnboarding = async (
    onboardingData: StandardizedOnboardingData,
    options?: CompleteOnboardingOptions
  ) => {
    try {
      if (!onboardingData) {
        throw new Error("Onboarding data not provided");
      }
      console.log("Standardized onboarding data:", onboardingData);

      // Validate the onboarding data
      const validation = validateOnboardingData(onboardingData);
      if (!validation.isValid) {
        throw new Error(
          `Invalid onboarding data: ${validation.errors.join(", ")}`
        );
      }

      console.log("Standardized onboarding data:", onboardingData);

      const merchantData = getMerchantForSaving(onboardingData);
      const storeData = getStoreForSaving(onboardingData);

      await handleUpdateSubscription(
        onboardingData.subscription?.planId || "free"
      );
      const savedMerchant = await handleSaveOnboardingMerchant(merchantData);

      if (!savedMerchant) {
        throw new Error("Failed to save merchant");
      }

      const storeToSave = {
        ...storeData,
        merchant: savedMerchant,
      };

      const savedStore = await handleSaveOnboardingStore(storeToSave);

      if (!savedStore) {
        throw new Error("Failed to save store");
      }
      toastSuccess("Onboarding completed successfully!");

      if (options?.onSuccess) {
        options.onSuccess();
      }

      window?.location?.reload();
      const redirectPath = options?.redirectPath || "/dashboard";
      navigate(redirectPath);
    } catch (error) {
      console.error("Error completing onboarding:", error);

      // Call error callback if provided
      if (options?.onError) {
        options.onError(error);
      }
    }
  };

  return handleCompleteOnboarding;
};
